import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { MessageService, SortEvent } from 'primeng/api'
import {
    MedicationService,
    ColumnChooserService,
    AppSettingService,
} from '../../../../api/services'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from 'src/app/carefinity/directives/customsort'
import { DataPageOfMedication, Medication, UiPreferences } from '../../../../api/models'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
    selector: 'app-medication-list',
    templateUrl: './medication-list.component.html',
    styleUrls: ['./medication-list.component.css'],
})
export class MedicationListComponent implements OnInit {
    Item = 'Medications'
    medications: DataPageOfMedication
    selectedPatient: Medication
    Lastpageindex: number = 1
    rows: number
    _selectedColumns: any[]
    showRecords: boolean = false

    private cols: any[]
    othercol: any[]

    pageNumber: number = 1
    sortby: string = 'Desc'
    demographicType: string = 'Medication'
    txtSearch: string = ''
    patientFullName
    showPatientDemographicPrint: boolean = false;
    pageSize: number = 0;
    preferences: UiPreferences = {};
    setPrintFlag: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private messageService: MessageService,
    private medservices: MedicationService,
    private columnchooserservice: ColumnChooserService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
      private appSetting: AppSettingService,

    ) { }

    ngOnInit() {

        this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;
        this.cols = [
            { field: 'shortStartDate', header: 'Start Date' },
            { field: 'brandDoseForm', header: 'Medication-Dose' },
            { field: 'rxQuanity', header: 'Qty' },
            { field: 'rxRefills', header: 'Refills' },
            { field: 'shortDateStopped', header: 'Stop Date' },
            { field: 'providerName', header: 'Entered By' },
        ]
        this.patientFullName = sessionStorage.getItem('ptName')
        this.bindMedicationList(this.pageNumber, this.sortby)

    this.appSetting
      .appSettingGetPracticeSettings$Response()
      .subscribe((res) => {
          this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
         
          if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
              this.setPrintFlag = true;
          }
          else {
              this.setPrintFlag = false;
          }
      })



        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.medications || 'Medications';
        }
    }

    @Input() get selectedColumns(): any[] {
        // console.log(this._selectedColumns);
        return this._selectedColumns
    }

    set selectedColumns(val: any[]) {
        let selectedValues = [...val]

        if (selectedValues.length == 0) {
            selectedValues = this._selectedColumns = [this.cols[0]]
        } else {
            //restore original order

            this._selectedColumns = val
        }

        let filteredData = Array.prototype.map
            .call(selectedValues, (s) => s.field)
            .toString()
        let filteredValue = Array.prototype.map
            .call(selectedValues, (s) => s.header)
            .toString()

        this.columnchooserservice
            .columnChooserColumnchooser({
                columnNames: filteredData,
                columnValue: filteredValue,
                type: this.demographicType,
            })
            .subscribe((result) => { })
    }
    customSort(event: SortEvent, num: number) {
        this.medications.data = this.cstsort.generalcustomSort(
            event,
            this.medications.data,
        )
    }
    bindMedicationList(pageNumber: number, sortbydirection: string) {
        this.medservices
            .medicationList({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                pageNumber: pageNumber,
                sortbydirection: sortbydirection,
                searchText: this.txtSearch,
            })
            .subscribe((respMedication) => {
                // console.log(X);

                this.medications = respMedication
                this.medications.data = respMedication.data.map((i) => ({

                    ...i,

                    ...i.otherColumns,

                }))
                this.rows = this.medications.pageSize

                if (this.medications.totalRecords > 0) {
                    this.showRecords = true
                } else {
                    this.showRecords = false
                }

                //for (var key in this.medications.data[0].otherColumns) {
                //    this.cols.push({ field: key, header: key });
                //}

                let addedFields = new Set(this.cols.map((col) => col.field))

                for (var key in this.medications.data[0].otherColumns) {
                    if (this.medications.data[0].otherColumns.hasOwnProperty(key)) {
                        // Check if key is already in addedFields set
                        if (!addedFields.has(key)) {
                            // Add to addedFields set
                            addedFields.add(key)

                            // Push to this.cols
                            this.cols.push({ field: key, header: key })
                        }
                    }
                }

                if (
                    this.medications.data[0].savedColumns != null &&
                    this.medications.data[0].savedColumns.length > 0
                ) {
                    var Savednames = this.medications.data[0].savedColumns.split(',')
                    this._selectedColumns = this.cols.filter((col) =>
                        Savednames.includes(col.field),
                    )
                } else {
                    this._selectedColumns = this.cols
                }
            })
    }

    searchMedications() {
        if (this.txtSearch.length > 1) {
            this.medications = null
            this.rows = null
            this.bindMedicationList(this.pageNumber, this.sortby)
        }
    }

    clearSearch() {
        if (this.txtSearch.length >= 0 || this.txtSearch == '') {
            this.txtSearch = ''
            this.bindMedicationList(this.pageNumber, this.sortby)
        }
    }

    printMedication() {
        var PrintMedication = document.getElementById(
            'PrintMedication_List',
        ) as HTMLElement
        const printWindow = window.open('', '_blank')
        if (printWindow) {
            const divContent = PrintMedication.innerHTML
            printWindow.document.open()
            printWindow.document.write(
                '<html><head><title>Print::Medication List</title>',
            )
            // Adding CSS styling for alternate rows
            printWindow.document.write('<style type="text/css">')
            printWindow.document.write(
                '    #Medication_print_table_tbody tbody tr:nth-child(odd) {',
            )
            printWindow.document.write('        background-color: #f2f2f2;')
            printWindow.document.write('    }')
            printWindow.document.write(
                '    #Medication_print_table_tbody tbody tr:nth-child(even) {',
            )
            printWindow.document.write('        background-color: #e6e6e6;')
            printWindow.document.write('    }')
            printWindow.document.write('</style>')
            printWindow.document.write('</head><body>')
            printWindow.document.write(divContent)
            printWindow.document.write('</body><html>')
            printWindow.document.close()
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        } else {
            console.error('Failed to open print window.')
        }
    }
}
